(function(){
  const TRIGGER=[9961214837041,9961188688177,10471023477041,10536670331185,10520509481265,10499112304945,10536677998897,10536676032817];
  const CARDS=[10674763792689,10676826145073,10676827521329,10676827947313,10676828373297,10676829126961];
  const HANDLES=[
    'メッセージカード-hello-new-baby',
    'メッセージカード-hello-big-sister',
    'メッセージカード-hello-big-brother',
    'メッセージカード-happy-birthday',
    'メッセージカード-thank-you',
    'メッセージカード-blank'
  ];
  let sel=null,prevHadTrigger=false;

  const origFetch=window.fetch;
  window.fetch=function(...a){
    const url=a[0];
    if(typeof url==='string'&&url.includes('/cart/add')){
      return origFetch.apply(this,a).then(r=>{setTimeout(check,500);return r;});
    }
    return origFetch.apply(this,a);
  };

  async function check(){
    const cart=await origFetch('/cart.js').then(r=>r.json());
    const alreadyHasCard=cart.items.some(i=>CARDS.includes(i.product_id));
    const hasTrigger=cart.items.some(i=>TRIGGER.includes(i.product_id));
    if(hasTrigger&&!prevHadTrigger&&!alreadyHasCard){
      showPopup();
    }
    prevHadTrigger=hasTrigger;
  }

  async function showPopup(){
    const overlay=document.getElementById('message-card-popup-overlay');
    const list=document.getElementById('message-card-list');
    sel=null;

    const products=await Promise.all(
      HANDLES.map(h=>origFetch('/products/'+h+'.json').then(r=>r.json()).then(d=>d.product).catch(()=>null))
    );
    const valid=products.filter(Boolean);
    if(!valid||valid.length===0)return;

    list.innerHTML=valid.map(p=>{
      const title=p.title.replace(/メッセージカード[｜|\]\s]*/,'').trim();
      const img=p.images&&p.images.length>0?p.images[0].src:'';
      const variantId=p.variants[0].id;
      return `<div class="mc-card-item" data-variant="${variantId}">
        ${img?`<img src="${img}" alt="${title}" loading="lazy">`:''}
        <span>${title}</span>
      </div>`;
    }).join('');

    const existing=document.getElementById('mc-add-btn');
    if(existing)existing.remove();
    list.insertAdjacentHTML('afterend','<button id="mc-add-btn" disabled>選ぶ</button>');

    list.querySelectorAll('.mc-card-item').forEach(el=>el.addEventListener('click',function(){
      list.querySelectorAll('.mc-card-item').forEach(i=>i.classList.remove('selected'));
      this.classList.add('selected');
      sel=this.dataset.variant;
      document.getElementById('mc-add-btn').disabled=false;
    }));

    document.getElementById('mc-add-btn').addEventListener('click',async function(){
      if(!sel)return;
      await origFetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:sel,quantity:1})});
      overlay.style.display='none';
    });

    document.getElementById('message-card-skip').addEventListener('click',()=>overlay.style.display='none');
    overlay.style.display='flex';
  }

  origFetch('/cart.js').then(r=>r.json()).then(c=>{
    prevHadTrigger=c.items.some(i=>TRIGGER.includes(i.product_id));
  });
})();
